import {
  HiOutlineBars3,
  HiOutlineArrowRightOnRectangle,
} from "react-icons/hi2";

import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router-dom";

import { logoutUser } from "../../../redux/features/auth/authSlice";

import "./Header.css";

/**
 * PAGE TITLES
 */
const pageTitles = {
  "/dashboard": "Dashboard",

  "/dashboard/users": "Gebruikers",

  "/dashboard/jongeren": "Jongeren",

  "/dashboard/registraties": "Registraties",

  "/dashboard/settings": "Instellingen",
};

export default function Header({ onMenuClick }) {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const location = useLocation();

  const { user } = useSelector((state) => state.auth);

  const currentTitle = pageTitles[location.pathname] || "POWER";

  /**
   * LOGOUT
   */
  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
    } finally {
      navigate("/login");
    }
  };

  return (
    <header className="header">
      {/* LEFT */}
      <div className="header__left">
        <button className="header__menu-button" onClick={onMenuClick}>
          <HiOutlineBars3 />
        </button>

        <div>
          <span className="header__eyebrow">POWER</span>

          <h1>{currentTitle}</h1>
        </div>
      </div>

      {/* RIGHT */}
      <div className="header__right">
        <div className="header__user">
          <span>
            {user?.first_name} {user?.last_name}
          </span>

          <small>{user?.email}</small>
        </div>

        <button className="header__logout" onClick={handleLogout}>
          <HiOutlineArrowRightOnRectangle />
        </button>
      </div>
    </header>
  );
}
